<template>
    <div>


        <div class="supplier-list" style="background-color: #ffffff;">
            <div class="supplier-panel" v-for="item in list" @click="pickSupplier(item)">
                <div class="supplier-name">{{item.supplier_name}}</div>
                <div class="supplier-desc">
                    {{item.contact_name}} {{item.contact_phone}} {{item.address}}
                </div>
            </div>
        </div>




    </div>
</template>


<script>
    import common from '../assets/js/common'
    import store from '../store'

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
            },
        data: function(){
            return {
                list:[]
            }
        },
        methods:{
            initPage()
            {
                common.cusHttp(this,'/api/supplier_list',{}).then((res)=>{
                    this.list = res.data.list;
                    console.log(this.list)
                })
            },
            pickSupplier(item)
            {
                //选择supplier
                store.commit('setChosenSupplier',item)
                this.$router.go(-1)
            }
        },
        created() {
            this.initPage()
        }
    }
</script>


<style>

    html,body{background-color: #f8f8f8!important;}

    input::-webkit-input-placeholder{
        padding-top: 0;
        line-height: normal ;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    .inEdit
    {
        opacity: .4;
    }

    .disableText{color:#999999 !important;}

    .in-bl{display: inline-block;}

    .common-padding{padding: 0 0.625rem;}
    .common-padding2{padding: 0.4rem 0.625rem;}

    .fc-aaaaaa-fs-nor-m{font-family: PingFangSC-Medium;font-size: 0.4375rem;color: #AAAAAA;line-height: .625rem;}

    .camera_text{line-height: 0.4rem;font-family: PingFangSC-Regular;font-size: 0.3rem;font-weight: normal;font-stretch: normal;letter-spacing: 0rem;color: #1889f9;}

    .bank-desc
    {
        font-family: PingFangSC-Regular;
        font-size: 0.438rem;
        color: #111111;
        line-height: 0.625rem;
    }

    .supplier-panel
    {
        padding: .5rem;
        position: relative;
    }

    .supplier-panel:not(:last-child)::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
    }

    .supplier-name{
        font-family: PingFangSC-Medium;
        font-size: 0.466rem;
        line-height: 0.666rem;
        text-align: left;
    }

    .supplier-desc
    {
        font-family: PingFangSC-Regular;
        font-size: 0.375rem;
        line-height: 0.666rem;
        text-align: left;
    }
</style>